export default __webpack_public_path__ + "static/chainlink-a36a2e78560b7adb1d33324675e778e1.png";